import { fetchWelcome, fetchAges } from "./api";
import { formatDate, diffDates } from "./utils";
import { parameterValue } from "./location";

const WEDNESDAY = 3;
const SATURDAY = 6;

export const addDays = (date, days) => {
  const retVal = new Date(date);
  retVal.setDate(retVal.getDate() + days);
  return retVal;
};

const checkLocalStorage = () => {
  if (localStorage.startDate !== undefined) {
    const startDate = new Date(localStorage.startDate);
    const now = new Date();

    if (formatDate(startDate) < formatDate(now)) {
      localStorage.removeItem("startDate");
      localStorage.removeItem("endDate");
      localStorage.removeItem("minDuration");
      localStorage.removeItem("maxDuration");
    }
  }
};

const extractAgeDate = (date) => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  date: date.getDate(),
});

const computeAgeRanges = (choices) => {
  const start = new Date(choices[0].range.max);
  const stop = new Date(choices[choices.length - 1].range.min);
  start.setDate(start.getDate() - 1);
  stop.setDate(stop.getDate() + 1);
  return {
    min: extractAgeDate(start),
    max: extractAgeDate(stop),
  };
};

const getStartDate = (stayFrom) => {
  const fromDay = stayFrom.getDay();
  return addDays(stayFrom, fromDay >= WEDNESDAY ? SATURDAY - fromDay : 0);
};

const getStayTo = (stayFrom, endDate) => {
  if (endDate !== undefined && endDate !== "") {
    return new Date(endDate);
  }

  const stayDay = stayFrom.getDay();

  const delta = stayDay === SATURDAY ? 7 : SATURDAY - stayDay;

  return addDays(stayFrom, delta);
};

export const computeStayDatesAuto = () => {
  const now = new Date();
  const stayFrom = getStartDate(now);
  const stayTo = getStayTo(stayFrom);

  return {
    stayFrom,
    stayTo,
  };
};

export const getStay = (startDate, endDate, minDuration, maxDuration) => {
  const dateParam = parameterValue("date");

  const now =
    dateParam !== undefined
      ? new Date(dateParam)
      : startDate !== undefined && startDate !== ""
      ? new Date(startDate)
      : new Date();

  const stayFrom =
    startDate !== undefined && startDate !== ""
      ? new Date(startDate)
      : getStartDate(now);
  const stayTo = getStayTo(stayFrom, endDate);
  return {
    stayFrom: formatDate(stayFrom),
    stayTo: formatDate(stayTo),
    startDate,
    endDate,
    minDuration,
    maxDuration:
      maxDuration === undefined ? diffDates(stayFrom, stayTo) : maxDuration,
  };
};

export const createInscription = (intermediary, resort, lang) => {
  checkLocalStorage();
  const startDate =
    localStorage.startDate !== undefined ? localStorage.startDate : "";
  const endDate =
    localStorage.endDate !== undefined ? localStorage.endDate : "";
  const minDuration =
    localStorage.minDuration !== undefined
      ? parseInt(localStorage.minDuration, 10)
      : 1;
  const maxDuration =
    localStorage.maxDuration !== undefined
      ? parseInt(localStorage.maxDuration, 10)
      : undefined;

  const stay = getStay(startDate, endDate, minDuration, maxDuration);

  return fetchWelcome(intermediary, resort, lang, stay.stayFrom).then(
    (resp) => {
      const { season } = resp;
      return {
        season,
        ...stay,
      };
    }
  );
};

export const fetchAgeRanges = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo
) => {
  return fetchAges(intermediary, resort, lang, season, stayFrom, stayTo).then(
    (result) => {
      const { choices, error } = result;
      return choices !== undefined && choices.length > 0
        ? computeAgeRanges(choices)
        : { error };
    }
  );
};



// WEBPACK FOOTER //
// ./src/services/clubmed.js